export const bewindvoerdersCuratorenNl = {
  BewindvoerdersCuratorenClientAanmeldenFormulierStapInleiding: "Inleiding",
  BewindvoerdersCuratorenClientAanmeldenFormulierMijnClient: "Mijn cliënt",
  BewindvoerdersCuratorenClientWijzigenFormulierStapInleiding: "Inleiding",
  BewindvoerdersCuratorenClientWijzigenFormulierMijnVraag: "Mijn vraag",
  BewindvoerdersCuratorenClientContactFormulierStapInleiding: "Inleiding",
  BewindvoerdersCuratorenClientContactFormulierMijnClient: "Mijn cliënt",
  UBentWsnp: "WSNP-bewindvoerder of curator bij faillissement",
  UBentFamilielidOnbekend: "Bewindvoerder of curator voor een familielid of bekende",
  UBentProfessional: "Professioneel bewindvoerder of curator"
};
